import { format, startOfDay } from 'date-fns'
import { WeekViewCategory } from '../types'

export type MomentMap = Map<string, string[]>

export const createMomentMap = (): MomentMap => new Map() as MomentMap

/** ex: 2022-03-25 */
export const formatDateKey = (date: Date): string =>
  format(startOfDay(date), 'yyyy-MM-dd')

export const formatCategoryKey = (category: WeekViewCategory): string =>
  typeof category.id === 'string'
    ? category.id.toLowerCase().replace(/\s/g, '-')
    : 'no-category'

export const makeMapKey = (
  date: Date,
  categoryId: WeekViewCategory['id']
): string => {
  const dateKey = formatDateKey(date)
  return JSON.stringify({ date: dateKey, category: categoryId })
}

export const addValueToMap = (
  map: MomentMap,
  mapKey: string,
  value: string
): void => {
  const currentValueAtKey = map.get(mapKey)

  // If we have an existing value at this key, push the new value onto the array
  if (currentValueAtKey) {
    currentValueAtKey.push(value)
    // If we don't have a value, instantiate an array for this key
  } else {
    map.set(mapKey, [value])
  }
}
